import script from "./ConversationTranscript.vue?vue&type=script&setup=true&lang=js"
export * from "./ConversationTranscript.vue?vue&type=script&setup=true&lang=js"

import "./ConversationTranscript.vue?vue&type=style&index=0&id=ce478112&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce478112"]])

export default __exports__